import type { Node } from 'slate';

import { Editor, Point, Range } from 'slate';

import type { OnKeyDown } from '@ui/MarkdownEditor/types';

import { CodeTabs, Html, JsxFlow, Recipe, ReusableContent, TableCell } from '../blocks';

const preventDeletingBlocks: OnKeyDown = (event, editor) => {
  if (!(event.key === 'Delete' && editor.selection && Range.isCollapsed(editor.selection))) return;

  const match = (n: Node) => [TableCell, CodeTabs, Html, Recipe, ReusableContent, JsxFlow].some(block => block.is(n));
  const after = Editor.after(editor, editor.selection.anchor);
  const entry = Editor.above(editor, { at: after, match });
  if (!after || !entry) return;

  const [, path] = entry;
  if (!Point.equals(after, Editor.start(editor, path))) return;

  event.preventDefault();
  event.stopPropagation();
};

export default [preventDeletingBlocks] as OnKeyDown[];
